import AppComponent from '../../mixins/app-component'

import AppHomeSlideNbTitle from '../app-home-slide-nb-title'
import AppIcon from '../app-icon'

export default
{
    name: 'app-home-slide-4',

    mixins: [
        AppComponent
    ],

    components: {
        AppHomeSlideNbTitle,
        AppIcon
    },

    props: {
        activeIndex: { type: Number, default: 0 },
        activeLevel: { type: Number, default: 0 }
    },

    data() {
        return {
            currentLevel: 0,
            lastlevel: 0,
            comingFromPosition: 'right',
            headerWidth: 0,
            headerWidthAndOffset: 0,
            pracsEarned: 0,
            pracsPrice: 0.025
        }
    },

    watch: {
        activeIndex: 'onActiveLevelChange',
        activeLevel: 'onActiveLevelChange',
        headerWidth: 'onHeaderWidthChange',
        priceForMappedArea: 'onPriceForMappedAreaChange',
        pracEarned: 'onPracEarnedChange'
    },

    created() {
        this.pracs = this.pracsPrice
        this.pracsEarned = this.pracsPrice
        this.pracsRunning = false
        
        this.eventHub.$on('window:resize', this.onResize)
        this.eventHub.$on('application:onEnterFrame', this.onEnterFrame)
    },

    mounted() {
        if (document.querySelector('.js-nav-container')) {
            this.headerWidth = document.querySelector('.js-nav-container').offsetWidth
        } else {
            this.eventHub.$on('app-header:mounted', this.onHeaderMounted)
        }

        this.pracContainer = this.$el.querySelector('.js-prac-earned-container')
    },

    destroyed() {
        this.eventHub.$off('app-header:mounted', this.onHeaderMounted)
        this.eventHub.$off('window:resize', this.onResize)
        this.eventHub.$off('application:onEnterFrame', this.onEnterFrame)
    },

    methods: {
        onActiveLevelChange() {
            if (this.activeIndex === 4) {
                this.lastLevel = this.currentLevel
                this.currentLevel = this.activeLevel

                if (this.currentLevel < this.lastLevel) {
                    this.comingFromPosition = 'right'
                } else if (this.currentLevel > this.lastLevel) {
                    this.comingFromPosition = 'left'
                }
                
                if (this.currentLevel === 1) {
                    this.pracs = this.pracsPrice
                    this.pracsEarned = this.pracsPrice
                    this.pracsRunning = false
                    this.pracContainer.classList.remove('is-hidden')
                } else if (this.currentLevel === 2) {
                    this.pracsRunning = true
                }
            } else {
                this.pracsRunning = false
            }
        },

        onHeaderMounted() {
            const $navContainer = document.querySelector('.js-nav-container')
            
            if ($navContainer) {
                this.headerWidth = $navContainer.offsetWidth
            }
        },

        onResize() {
            const $navContainer = document.querySelector('.js-nav-container')
            
            if ($navContainer) {
                this.headerWidth = $navContainer.offsetWidth
                this.headerWidthAndOffset = this.headerWidth + (this.$root.width / 12 * 2) - 20 /* $paddings["xs"] */

                this.headerWidthAndOffset = this.headerWidthAndOffset < (this.$root.width / 3) ? (this.$root.width / 3) : this.headerWidthAndOffset
            }
        },

        onHeaderWidthChange() {
            this.headerWidthAndOffset = this.headerWidth + (this.$root.width / 12 * 2) - 20 /* $paddings["xs"] */

            this.headerWidthAndOffset = this.headerWidthAndOffset < (this.$root.width / 3) ? (this.$root.width / 3) : this.headerWidthAndOffset
        },

        _onClickOnGetMap() {
            this.eventHub.$emit('page-home:onNextSlide', this.onNextSlide)
        },
        
        onEnterFrame() {
            if (this.pracsRunning) {
                this.pracs += (0 - this.pracs) * 0.08
                this.pracsEarned = this.pracs.toFixed(3)
                
                if (this.pracs < 0.001) {
                    this.pracContainer.classList.add('is-hidden')
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-home-slide-4/script.js